import { Component } from 'utils';

@Component({
    ControllerAs: 'vm',
    template: require('./projectMenu.tpl.html')
})
export class ProjectMenuComponent {
    static $inject = [];

    constructor() {
    };
}



// WEBPACK FOOTER //
// ./src/app/authorized/project/pipeline/projectMenu/projectMenu.js